export default __webpack_public_path__ + "static/media/intro-wave-dark.777cc137.webp";